<!-- ── Trigger ───────────────────────────────────────────────────────────── -->
<button
  type="button"
  class="fm__trigger"
  [class.fm__trigger--active]="activeCount() > 0 || isOpen()"
  (click)="toggle($event)"
>
  Filtros @if (activeCount() > 0) { ({{ activeCount() }}) }
  <svg class="fm__trigger-chevron" [class.fm__trigger-chevron--open]="isOpen()"
    width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
</button>

<!-- ── Panel principal (position: fixed) ─────────────────────────────────── -->
@if (isOpen() && panelRect()) {
  <div
    class="fm__panel"
    [style.top.px]="panelRect()!.top"
    [style.left.px]="panelRect()!.left"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="fm__panel-header">
      <span class="fm__panel-title">Filtros</span>
      @if (activeCount() > 0) {
        <button type="button" class="fm__clear-btn" (click)="clearAll($event)">
          Borrar todos
        </button>
      }
    </div>

    <!-- Grupos -->
    @for (group of filters(); track group.prefix; let idx = $index) {
      <div
        class="fm__group-row"
        [class.fm__group-row--active]="hoveredGroupIdx() === idx"
        (mouseenter)="onGroupEnter($event, idx)"
        (mouseleave)="onGroupLeave()"
      >
        <span class="fm__group-name">
          {{ group.name }}
          @if (groupActiveCount(group) > 0) {
            <span class="fm__group-count">({{ groupActiveCount(group) }})</span>
          }
        </span>
        <svg class="fm__group-chevron" width="11" height="11" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </div>
    }
  </div>
}

<!-- ── Flyout de opciones (position: fixed, abre a la DERECHA) ───────────── -->
@if (hoveredGroupIdx() !== null && flyoutRect()) {
  <div
    class="fm__flyout"
    [style.top.px]="flyoutRect()!.top"
    [style.left.px]="flyoutRect()!.left"
    (mouseenter)="onFlyoutEnter()"
    (mouseleave)="onFlyoutLeave()"
    (click)="$event.stopPropagation()"
  >
    <!-- Header del flyout -->
    <div class="fm__flyout-header">{{ filters()[hoveredGroupIdx()!].name }}</div>

    <!-- Opciones -->
    @for (val of filters()[hoveredGroupIdx()!].values; track val.value) {
      <div class="fm__option" (click)="toggleValue(filters()[hoveredGroupIdx()!], val)">
        <span class="fm__option-label">{{ val.name }}</span>
        @if (val.selected) {
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        }
      </div>
    }
  </div>
}
